import { ORG_NAME_PATTERN } from '../../Shared/constants/orgConstants';

export const EXCEL_ICON_LINK =
  'https://m.media-amazon.com/images/G/31/AdSlot/excel-icon-image.png';

export const MAX_INLINE_ERROR_COUNT = 10;
export const ROW_NUMBER_OFFSET = 2;

export const BEAN_VALIDATION_PATTERN = /\w+\[\d+\]\.\w+:/;
export const BEAN_VALIDATION_PARSE_PATTERN = /\w+\[(\d+)\]\.\w+:\s*(.+)/;
export const FILE_EXTENSION_PATTERN = /\.(csv|xlsx|xls)$/i;

export enum FileUploadErrorCode {
  CSV_PARSING_ERROR = 'CSV_PARSING_ERROR',
  VALIDATION_ERROR = 'VALIDATION_ERROR',
  BATCH_FAILURE = 'BATCH_FAILURE',
}

export enum FileType {
  AE = 'AE',
  INVENTORY = 'INVENTORY',
  ADVERTISERS = 'ADVERTISERS',
  CATEGORY = 'CATEGORY',
  TYPE_OF_PURCHASE = 'TYPE_OF_PURCHASE',
  CONTEXTUAL_INVENTORY = 'CONTEXTUAL',
  NON_CONTEXTUAL_INVENTORY = 'NON_CONTEXTUAL',
}

export enum InventoryType {
  CONTEXTUAL = 'CONTEXTUAL',
  NON_CONTEXTUAL = 'NON_CONTEXTUAL',
}

export const ALLOWED_EXTENSIONS = ['.xlsx', '.xls'];

export const AE_HEADERS = ['First Name', 'Last Name', 'Email', 'Category', 'Org Name'];
export const ADVERTISER_HEADERS = [
  'Rodeo Advertiser Name',
  'Brand Name',
  'Org Name',
  'Categories',
];
export const INVENTORY_HEADERS = [
  'Slot_Packages',
  'Segment',
  'CPM',
  'Impressions',
  'Category',
  'availability',
];

export const CONTEXTUAL_INVENTORY_HEADERS = [
  'Slot-Packages',
  'Segment',
  'CPM',
  'Overall Impressions',
  'Overall Value',
  'Availability',
  'Type of Purchase',
  'Category',
];
export const NON_CONTEXTUAL_INVENTORY_HEADERS = [
  'Slot-Packages',
  'Segment',
  'CPM',
  'Overall Impressions',
  'Overall Value',
  'Availability',
  'Type of Purchase',
  'Category',
];

export const CATEGORY_HEADERS = ['Category Name'];

export const TYPE_OF_PURCHASE_HEADERS = ['Purchase Type'];

const TYPE_OF_PURCHASE_REGEX = /^[a-zA-Z0-9\s\-_]{2,50}$/;

// Regex patterns for each column
export const AE_COLUMN_PATTERNS = {
  'First Name': /^[a-zA-Z\s_]{1,50}$/,
  'Last Name': /^[a-zA-Z\s_]{1,50}$/,
  Email: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
  Category: /^[a-zA-Z0-9\s]{2,30}$/,
  'Org Name': ORG_NAME_PATTERN,
};

export const ADVERTISER_COLUMN_PATTERNS = {
  'Rodeo Advertiser Name': /^[a-zA-Z0-9\s\-_&+/",()']{2,50}$/,
  'Brand Name': /^[a-zA-Z0-9\s\-_&+/",()']{2,50}$/,
  'Org Name': ORG_NAME_PATTERN,
  Categories: /^[a-zA-Z0-9\s\-_]{2,30}(,[a-zA-Z0-9\s\-_]{2,30})*$/,
};

export const CATEGORY_COLUMN_PATTERNS = {
  'Category Name': /^[a-zA-Z0-9\s\-_]{2,30}$/,
};

export const TYPE_OF_PURCHASE_COLUMN_PATTERNS = {
  'Purchase Type': TYPE_OF_PURCHASE_REGEX,
};

export const CONTEXTUAL_INVENTORY_COLUMN_PATTERNS = {
  'Slot-Packages': /^[a-zA-Z0-9\s\-_&+/",()']{2,200}$/,
  Segment: /^.{2,200}$/,
  CPM: /^\d+(\.\d{1,2})?$/,
  'Overall Impressions': /^\d+$/,
  'Overall Value': /^[0-9\s_]{2,30}$/,
  Availability: /^\d+$/,
  'Type of Purchase': TYPE_OF_PURCHASE_REGEX,
  Category: /^[a-zA-Z0-9\s\-_]{2,30}(,[a-zA-Z0-9\s\-_]{2,30})*$/,
};

export const NON_CONTEXTUAL_INVENTORY_COLUMN_PATTERNS =
  CONTEXTUAL_INVENTORY_COLUMN_PATTERNS;

// Primary key columns for duplicate validation
// Single column (string) or composite key (array of strings)
export const PRIMARY_KEY_COLUMNS = {
  [FileType.AE]: 'Email',
  [FileType.ADVERTISERS]: 'Rodeo Advertiser Name',
  [FileType.INVENTORY]: 'Slot-Packages',
  [FileType.CATEGORY]: 'Category Name',
  [FileType.TYPE_OF_PURCHASE]: 'Purchase Type',
  // Composite key: Slot-Packages + Segment + Type of Purchase
  [FileType.CONTEXTUAL_INVENTORY]: ['Slot-Packages', 'Segment', 'Type of Purchase'],
  [FileType.NON_CONTEXTUAL_INVENTORY]: ['Slot-Packages', 'Segment', 'Type of Purchase'],
};
